import { BaseContainerModel } from '../../../base-container.model';
import {
    bl_alg_cc_queue_hdr_RowClass,
    bl_alg_cc_queue_hdr_RowInterface,
} from '../../../../dbschema';

export class TaskRouterQueueContainerModel extends BaseContainerModel {
    bl_alg_cc_queue_hdr: bl_alg_cc_queue_hdr_RowInterface =
    new bl_alg_cc_queue_hdr_RowClass();
}
